import { render } from "./DoltzTermsOfUseView.vue?vue&type=template&id=7a459d3c"
import script from "./DoltzTermsOfUseView.vue?vue&type=script&lang=js"
export * from "./DoltzTermsOfUseView.vue?vue&type=script&lang=js"

import "./DoltzTermsOfUseView.vue?vue&type=style&index=0&id=7a459d3c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__